import type { Revision, RevisionPage } from '../../types';
import { mutations } from '../../utils';
import { getPageParentInRevision } from './getPageParentInRevision';

/**
 * Get the ancestors of a page. It includes the current page.
 */
export function getPageAncestorsInRevision(revision: Revision, pageId: string): RevisionPage[];
export function getPageAncestorsInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPage>[];
export function getPageAncestorsInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPage>[] {
    const pages = mutations.get(revision, 'pages');
    const parent = getPageParentInRevision(revision, pageId);
    const page = mutations.get(pages, pageId);

    if (!parent) {
        return [page];
    }

    return [...getPageAncestorsInRevision(revision, mutations.get(parent, 'id')), page];
}
